module.exports = __webpack_public_path__ + "img/_011.e66fa977.png";